import { BlockItem } from "@components/atoms/BlockItem"
import { BlockWrapper } from "@components/atoms/BlockWrapper"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "About Donate",
}

export default defineBlock("about/donate", (props) => {
  const LinkEl = props.link && !env.admin ? Link : "div"
  const linkElProps = props.link ? { href: props.link, target: "_blank" } : {}

  return (
    <BlockWrapper>
      <BlockItem className="bg-green">
        <div className="flex justify-center items-center">
          <LinkEl {...linkElProps} className="w-full text-center flex justify-center items-center">
            <EditableText
              as="div"
              className="type-title-xl leading-none my-[0.7em] relative before:absolute before:bottom-0 before:left-0 before:h-1 before:bg-current before:w-0 before:transition-all md:hover:before:w-full"
              store="title"
              inlineToolbar={false}
              defaultValue="Donate to NZHF"
              placeholder="Donate to NZHF"
            />
          </LinkEl>
        </div>
      </BlockItem>
    </BlockWrapper>
  )
})